import { isString } from 'lodash-es';

export const pnDataTypes = [
  'wells',
  'wells_usa',
  'pipelines',
  'facilities',
  'mineral_rights',
  'open_mineral_rights',
  'crown_mineral_activity',
  'land_postings',
  'units',
  'pools',
  'dispositions',
  'dispositions_historical',
  'grids',
] as const;

export type PNDataType = (typeof pnDataTypes)[number];

export function isPNDataType(arg: unknown): arg is PNDataType {
  return isString(arg) && pnDataTypes.includes(arg as PNDataType);
}
